<div>
  <div class="relative mb-[26px]">
    <div class="overflow-x-auto">
      <table class="w-[1200px] !bg-transparent" mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="report_id">
          <th mat-header-cell *matHeaderCellDef>Report ID</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700">
            <div class="flex items-center gap-2">
              {{ element.id }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="report_type">
          <th mat-header-cell *matHeaderCellDef>Report type</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700">
            <div class="flex items-center gap-2">
              @switch (element.process) {
                @case ('FIRST_REPORT') {
                  First report
                }
                @case ('TOP_10') {
                  TOP-10
                }
                @case ('AML_WALLET_CHECK') {
                  Check Wallet
                }
                @case ('MONITORING_WALLET_CHECK') {
                  Monitoring check Wallet
                }
                @default {
                  {{ element.process }}
                }
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Report time</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700">
            <span class="opacity-70">{{ element.createdDate | date: 'HH:mm' }}, </span>
            <span>{{ element.createdDate | date: 'dd.MM.yyyy' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="wallet">
          <th mat-header-cell *matHeaderCellDef>Wallet</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700">
            <div class="flex items-center gap-2">
              {{ element.address || '---' }}
              <app-copy-button (click)="$event.stopPropagation()" [currentColor]="'text-[#7A9095] opacity-50'"
                               [value]="element.address"
                               [size]="'small'"></app-copy-button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="risk_score">
          <th mat-header-cell *matHeaderCellDef>Risk Score</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700">
            <div class="flex items-center gap-[10px] text-[14px]">
              @switch (element.riskLevel) {
                @case ('LOW') {
                  <div class="flex items-center gap-1 bg-aml-green-600 rounded py-[3px] px-[7px]">
                    <mat-icon svgIcon="risk-low" class="w-[7px] max-w-[7px] h-[7px] max-h-[7px]"></mat-icon>
                    <span class="text-white text-[11px]">Low</span>
                  </div>
                }
                @case ('MEDIUM') {
                  <div class="flex items-center gap-1 bg-[#D3A500] rounded py-[3px] px-[7px]">
                    <mat-icon svgIcon="risk-medium" class="w-[4px] max-w-[4px] h-[8px] max-h-[8px]"></mat-icon>
                    <span class="text-aml-black-100 text-[11px]">Medium</span>
                  </div>
                }
                @case ('HIGH') {
                  <div class="flex items-center gap-1 bg-[#E74949] rounded py-[3px] px-[7px]">
                    <mat-icon svgIcon="risk-high" class="w-[4px] max-w-[4px] h-[8px] max-h-[8px]"></mat-icon>
                    <span class="text-white text-[11px]">High</span>
                  </div>
                }
                @case ('SEVERE') {
                  <div class="flex items-center gap-1 bg-aml-red-100 rounded py-[3px] px-[7px]">
                    <mat-icon svgIcon="risk-severe" class="w-[10px] max-w-[10px] h-[10px] max-h-[10px]"></mat-icon>
                    <span class="text-white text-[11px]">Severe</span>
                  </div>
                }
                @default {
                  ---
                }
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="nickname">
          <th mat-header-cell *matHeaderCellDef>
            @if (nicknamesList() && nicknamesList().length > 1) {
              <mat-form-field class="table-head-select">
                <mat-label>Nickname</mat-label>
                <mat-select placeholder="Nickname" [panelClass]="'panel-table-head-select'"
                            [formControl]="filterNickname">
                  <mat-option [value]="null">All</mat-option>
                  @for (name of nicknamesList(); track name) {
                    <mat-option [value]="name">{{ name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            } @else {
              <span>Nickname</span>
            }
          </th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700">
            {{ element.walletName ?? '---' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="service_fee">
          <th class="min-w-[120px]" mat-header-cell *matHeaderCellDef>Service Fee</th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700">
            @if ((!element.commissionAmount || element.commissionAmount === 0)) {
              <mat-icon class="!w-[19px] !h-[19px] !min-w-[19px]" svgIcon="round-succes-outline"></mat-icon>
            } @else {
              {{ (element.commissionAmount | number:('1.2-2')) ?? '---' }} USDT
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="review">
          <th mat-header-cell *matHeaderCellDef>
            <div class="flex items-center justify-between">
              <span>Review</span>
            </div>
          </th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700">
            <button type="button" mat-ripple
                    class="btn-main text-[14px] font-medium text-[#2D67F7] border border-solid rounded-[4px] border-[#2D67F7] py-2 px-[18px]">
              Review
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="table_settings" stickyEnd>
          <th class="table_settings" mat-header-cell *matHeaderCellDef>
            <div class="!w-[10px] !max-w-[10px]"></div>
          </th>
          <td *matCellDef="let element" mat-cell class="text-aml-green-700 hover-bg-sticky !bg-white">
            <span></span>
          </td>
        </ng-container>

        <tr *matNoDataRow class="mat-mdc-row mdc-data-table__row">
          <td [attr.colspan]="displayedColumns.length"
              class="mat-mdc-cell mdc-data-table__cell"
              style="text-align: center">
            <div class="flex justify-center items-center px-5 py-10">
              <img alt="data-empty"
                   height="146"
                   priority
                   ngSrc="assets/icons/data-empty.svg"
                   width="227">
            </div>
          </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"
            class="[&>th]:!bg-[#E4E5E5] [&>th]:!bg-opacity-40 text-aml-green-700 rounded-[7px]
            first:[&>th]:pl-[22px] [&>th]:text-aml-green-700/40 [&>th]:!border-none !font-base
            !h-auto [&>th]:h-[30px] [&>th]:px-[10px] first:[&>th]:rounded-l-[7px] last:[&>th]:rounded-r-[7px]"
        >
        </tr>
        <tr mat-row *matRowDef="let report; columns:displayedColumns" (click)="viewReport(report)"
            class="
            first:[&>td]:pl-[22px] [&>td]:px-[10px] !bg-white hover:!bg-[rgba(45,103,247,0.05)]
            cursor-pointer shadow-table-row rounded-[6px] !h-[60px] !font-base"
            [ngClass]="{ 'bg-row-open': markOpenRow() === report.id}"
        >
        </tr>
      </table>
    </div>

    @if (displayedColumns.includes('table_settings')) {
      <div class="absolute top-0 right-0 z-50 w-[30px] flex items-center justify-center h-[30px] bg-[#eef0f0]">
        <mat-icon class="!w-[13px] !h-[13px]" svgIcon="settings" [matMenuTriggerFor]="menu"></mat-icon>
        <mat-menu class="menu-custom-scroll pr-[3px] py-[6px] !rounded-[9px]" #menu="matMenu" [hasBackdrop]="true">
          <div class="max-h-[316px] overflow-auto min-w-[225px]" cdkScrollable>
            <div cdkDropList class="menu-list" (cdkDropListDropped)="drop($event)">
              @for (displayedColumn of allDisplayedColumns; track displayedColumn) {
                @if (!['table_settings'].includes(displayedColumn)) {
                  <div class="menu-item" cdkDrag>
                    <mat-icon class="cursor-move !w-[6.5px]" cdkDragHandle
                              svgIcon="aml_drag_handler"></mat-icon>
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  [ngModel]="!filteredDisplayedColumns.includes(displayedColumn)"
                                  (change)="handlerChangeDisplayColumnCheckbox($event, displayedColumn)"></mat-checkbox>
                    {{ displayedColumn | transformUnderscoreToSpace | titlecase }}
                  </div>
                }
              }
            </div>
          </div>
        </mat-menu>
      </div>
    }
  </div>
  <mat-paginator
    (page)="pageEvent.emit($event)"
    [length]="paginationOptions().length"
    [pageSizeOptions]="paginationOptions().pageSizeOptions"
    aria-label="Select page">
  </mat-paginator>
</div>
